import * as mutationType from "../mutation_types";
import _ from "lodash";

const state = {
  list: [],
  history: [],
  annualreview: {},
  tab: 0,
  drawer: false,
  ready: [],
  signoff_ready: [],
  overview: {}
};

const getters = {
  list: state => state.list,
  history: state => state.history,
  annualreview: state => state.annualreview || {},
  tab: state => state.tab,
  drawer: state => state.drawer,
  question_count: state =>
    _.reduce(
      state.annualreview.sections,
      function(sum, section) {
        return sum + section.questions.length;
      },
      0
    ),
  is_user: (state, getters, rootState, rootGetters) =>
    getters.annualreview.user.id == rootGetters["profile/profile"].id,
  completed_answers: (state, getters, rootState, rootGetters) =>
    getters.annualreview.answers.filter(
      x => x.answererId == rootGetters["profile/profile"].id
    ),
  ready: state => state.ready,
  signoff_ready: state => state.signoff_ready,
  overview: state => state.overview
};

const actions = {
  getAnnualReviewOverview({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/annualreviews/overview`)
        .then(res => {
          commit(mutationType.SET_ANNUAL_REVIEW_OVERVIEW, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAnnualReviews({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/annualreviews`)
        .then(res => {
          commit(mutationType.SET_ANNUAL_REVIEWS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAllAnnualReviews({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/annualreviews/all`)
        .then(res => {
          commit(mutationType.SET_ANNUAL_REVIEWS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAnnualReview({ commit }, request) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/annualreviews/${request.userId}/${request.id}`)
        .then(res => {
          commit(mutationType.SET_ANNUAL_REVIEW, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAnnualReviewHistory({ commit }, userId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/annualreviews/${userId}/history`)
        .then(res => {
          commit(mutationType.SET_ANNUAL_REVIEW_HISTORY, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  setDrawer({ commit }, val) {
    return new Promise(resolve => {
      commit(mutationType.SET_ANNUAL_REVIEW_DRAWER, val);
      resolve();
    });
  },
  setTab({ commit }, val) {
    return new Promise(resolve => {
      commit(mutationType.SET_ANNUAL_REVIEW_TAB, val);
      resolve();
    });
  },
  saveQuestionAnswer({ commit }, answer) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(
          `/api/annualreviews/${answer.userId}/${answer.annualReviewId}/answers`,
          answer
        )
        .then(res => {
          commit(mutationType.SET_ANNUAL_REVIEW_ANSWER, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  completeQuestions({ commit, state }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `/api/annualreviews/${state.annualreview.user.id}/${state.annualreview.id}/completequestions`
        )
        .then(res => {
          commit(mutationType.SET_ANNUAL_REVIEW_COMPLETE_QUESTIONS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveRatingAndPay({ commit, state }, annualreview) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(
          `/api/annualreviews/${state.annualreview.user.id}/${state.annualreview.id}`,
          annualreview
        )
        .then(() => {
          commit(mutationType.SET_ANNUAL_REVIEW_RATING, annualreview);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  signoff({ commit, state }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `/api/annualreviews/${state.annualreview.user.id}/${state.annualreview.id}/signoff`
        )
        .then(res => {
          commit(mutationType.SET_ANNUAL_REVIEW_SIGNOFF, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  complete({ commit }, annualreview) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `/api/annualreviews/${annualreview.user.id}/${annualreview.id}/complete`
        )
        .then(() => {
          commit(mutationType.SET_ANNUAL_REVIEW_COMPLETE, annualreview);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getReady({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/annualreviews/ready`)
        .then(res => {
          commit(mutationType.SET_ANNUAL_REVIEWS_READY, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSignoffReady({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/annualreviews/signoffready`)
        .then(res => {
          commit(mutationType.SET_ANNUAL_REVIEWS_SIGNOFF_READY, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_ANNUAL_REVIEW_OVERVIEW](state, overview) {
    state.overview = overview;
  },
  [mutationType.SET_ANNUAL_REVIEWS](state, list) {
    state.list = list;
  },
  [mutationType.SET_ANNUAL_REVIEW](state, item) {
    state.annualreview = item;
  },
  [mutationType.SET_ANNUAL_REVIEW_TAB](state, tab) {
    state.tab = tab;
  },
  [mutationType.SET_ANNUAL_REVIEW_DRAWER](state, show) {
    state.drawer = show;
  },
  [mutationType.SET_ANNUAL_REVIEW_HISTORY](state, list) {
    state.history = list;
  },
  [mutationType.SET_ANNUAL_REVIEW_ANSWER](state, item) {
    var index = state.annualreview.answers.findIndex(
      x => x.questionId == item.questionId && x.answererId == item.answererId
    );

    if (index >= 0) {
      state.annualreview.answers[index] = Object.assign(
        state.annualreview.answers[index],
        item
      );
    } else {
      state.annualreview.answers.push(item);
    }
  },
  [mutationType.SET_ANNUAL_REVIEW_COMPLETE_QUESTIONS](state, item) {
    state.annualreview = Object.assign(state.annualreview, item);
  },
  [mutationType.SET_ANNUAL_REVIEW_RATING](state, item) {
    state.annualreview = Object.assign(state.annualreview, item);
  },
  [mutationType.SET_ANNUAL_REVIEW_SIGNOFF](state, item) {
    state.annualreview = Object.assign(state.annualreview, item);
  },
  [mutationType.SET_ANNUAL_REVIEW_COMPLETE](state, item) {
    var index = state.list.findIndex(x => x.id == item.id);

    if (index >= 0) {
      state.list[index].complete = true;
    }
  },
  [mutationType.SET_ANNUAL_REVIEWS_READY](state, list) {
    state.ready = list;
  },
  [mutationType.SET_ANNUAL_REVIEWS_SIGNOFF_READY](state, list) {
    state.signoff_ready = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
